import {useEffect, useState} from 'react'
import fetchApi from './fetchApi'

/**
 * fetch 를 사용하는 Hooks로 loading, error, data, refetch등을 추상화함.
 * useFetch사용시 바로 fetch 수행
 * @param {RequestInfo} input fetch input
 * @param {RequestInit} init fetch init
 */
export default function useFetch(input, init) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState()
  const [data, setData] = useState()
  const [timestamp, setTimestamp] = useState()

  function refetch() {
    setTimestamp(+new Date())
  }

  useEffect(() => {
    setLoading(true)
    fetchApi(input, init)
      .then(data => {
        setData(data)
        setLoading(false)
        setError('')
      })
      .catch(err => {
        setError(err)
        setLoading(false)
        return err
      })
    // return () => {}
  }, [input, init, timestamp])

  return {loading, error, data, refetch}
}
